export const getShortcodeAttribute = (shortcode: string, name: string): string | undefined =>
    shortcode.match(new RegExp(`\\s${name}="([^"]*)"`))?.[1]

export const getShortcodeIntAttribute = (shortcode: string, name: string): number | undefined => {
    const value = parseInt(getShortcodeAttribute(shortcode, name) ?? "")
    return isNaN(value) ? undefined : value
}
